import { ClipLoader } from "react-spinners";
import { Constants } from "../../../../../../common/constants";
import { SyncDirection } from "../../../../../../common/sesh_types";
import { SyncEntity } from "../../../../../../src/entity/Sync";
import { DashboardUtils } from "../../../dashboard_utils";
import { ErrorTooltip } from "../../../forms/improved_components/tooltips/error_tooltip";
import { trpc } from "../../../utils/trpc";
import ActionButton, { ActionButtonState } from "./action_button";
import { ChannelTag } from "./channel_tag";
import { GoogleCalendarTag } from "./google_calendar_tag";
import { SyncDirectionPreposition } from "./sync_direction_preposition";
import { SyncInclusionTag } from "./sync_inclusion_tag";

export function SyncBox(props: {
	guild_id: string;
	sync: SyncEntity;
	onEditClicked: (sync: SyncEntity) => void;
}) {
	const utils = trpc.useContext();

	const deleteSyncMutation = trpc.gcal.deleteSync.useMutation({
		onSuccess: () => {
			utils.gcal.getSyncsOrAuthURL.setData(
				(data) => {
					const isLoggedIn = data.isLoggedIn;

					if (!isLoggedIn) {
						return data;
					}

					return {
						...data,
						syncs: data.syncs?.filter((val) => val.id !== sync.id),
					};
				},
				{ guild_id: props.guild_id }
			);
			utils.gcal.getSyncsOrAuthURL.invalidate();
		},
	});

	const { sync } = props;

	const actions = deleteSyncMutation.isLoading ? (
		<ClipLoader
			size={"1rem"}
			loading={true}
			color={Constants.EMBED_COLOR}
		/>
	) : (
		<>
			<ActionButton
				button_class="manual-link"
				font_awesome_class="fas fa-pencil-alt"
				action_verb="Edit"
				on_click_func={() => {
					props.onEditClicked(sync);
				}}
				state={ActionButtonState.Enabled}
				className="ml-auto"
			/>
			<ActionButton
				button_class="error-link"
				font_awesome_class="far fa-trash-alt"
				on_click_func={() => {
					DashboardUtils.ShowDeleteConfirmAlert(
						"Are you sure you want to delete this sync?"
					).then((val) => {
						if (!val.isConfirmed) {
							return;
						}
						deleteSyncMutation.mutate({
							sync_id: sync.id,
						});
					});
				}}
				action_verb="Delete"
				state={ActionButtonState.Enabled}
			/>
		</>
	);

	return (
		<div key={sync.id} className="sync-box flex min-w-0 max-w-full gap-4">
			<div className="white-text flex w-full min-w-0 items-center gap-2">
				{sync.error_code && (
					<ErrorTooltip
						info={
							<div className="flex w-full max-w-full rounded-sm text-sm">
								Status Code: {sync.error_code}
								<br />
								{sync.error_message}
							</div>
						}
					></ErrorTooltip>
				)}
				<div className="flex w-full min-w-0 max-w-full flex-col items-center gap-2 sm:flex-row">
					{sync.sync_direction === SyncDirection.Outbound && (
						<SyncInclusionTag sync={sync} />
					)}
					{/* <SyncDirectionArrow sync={sync} /> */}
					{sync.sync_direction === SyncDirection.Inbound && (
						<GoogleCalendarTag sync={sync} />
					)}
					<span className="self-center justify-self-center">
						<SyncDirectionPreposition sync={sync} />
					</span>
					{sync.sync_direction === SyncDirection.Outbound && (
						<GoogleCalendarTag sync={sync} />
					)}
					{sync.sync_direction === SyncDirection.Inbound && (
						<ChannelTag id={sync.output_channel} />
					)}
				</div>
				{/* TODO: improve bidirectional rendering? */}
			</div>

			<div className="flex flex-col justify-center gap-4 sm:flex-row">
				{actions}
			</div>
		</div>
	);
}
